import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetMergedReportAvailableMonths} from '@/features/accesses/activity-report/http/mergedReportExport.http'
import {AvailableMergedReportMonths} from '@/features/accesses/activity-report/types'

// Periods with both sector reports ready — drives the month select in the merged-report export card.
export const useGetMergedReportAvailableMonths = (
    options?: Omit<UseQueryOptions<AvailableMergedReportMonths>, 'queryKey' | 'queryFn'>
) =>
    useQuery({
        queryKey: [QUERY_KEYS.MERGED_REPORT_AVAILABLE_MONTHS],
        queryFn: httpGetMergedReportAvailableMonths,
        ...options
    })
